import Login from "@/ClientApplication/Login.tsx";
import { Container } from "@mui/material";
import type { ReactNode } from "react";

const PublicClientLogin = (): ReactNode => {
    return (
        <Container
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                height: "100vh",
                backgroundColor: "#313131",
            }}
        >
            <Login />
        </Container>
    );
};

export default PublicClientLogin;
